import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('intelligentOutboundCallStore')
@observer
class intelligentOutboundCall extends Component {
  render() {
    const { intelligentOutboundCallStore, location } = this.props
    const { isFetching } = intelligentOutboundCallStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location} />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default intelligentOutboundCall;
